/**
 * @file help.component.ts
 */
import { Component } from '@angular/core';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: [],
    standalone: false
})
export class HelpComponent {

  constructor() { }

}
